<template>
  <div class="content-block">
    <CompanyTemplateForm
      :templateId="templateId"
      @done="$router.push({name: 'settingsCompanyTemplateList'})"
    >
    </CompanyTemplateForm>
  </div>
</template>

<script>
import { get } from 'lodash'
import CompanyTemplateForm from 'CORE/components/settings/company-template/form'

export default {
    name: 'SettingsCompanyTemplateDetailView',
    components: {
        CompanyTemplateForm,
    },
    computed: {
        templateId() {
            return get(this.$route.params, 'id', null)
        },
    },
}
</script>
